import { computed } from 'vue'

import { currencyFilter, currencySymbol as utilsCurrencySymbol } from '@last/core'

import { useConfigStore } from '@/store/config'

export const useMoney = () => {
  const config = useConfigStore()
  const currencyCode = config.config?.currencyCode || 'EUR'

  function currency(value: number): string {
    return currencyFilter(value, currencyCode)
  }

  const currencySymbol = computed(() => {
    return utilsCurrencySymbol(currencyCode)
  })

  function formatNumber(value: number): string {
    const regexp = /^([\d,.]+)/gm
    const withCurrency = currencyFilter(value, currencyCode)
    const cleanValue = regexp.exec(withCurrency)

    return cleanValue ? cleanValue[0] : ''
  }

  return {
    currencySymbol,
    currency,
    formatNumber
  }
}
